/**
 * PasswordReset actions
 */
import Constants from '../../constants';

const { Auth } = Constants;

/**
 * Action object dispatched to authenticate login
 *
 * @param {string} email user login email
 * @param {string} password user login password
 */
const login = (email, password, token2FA, method2FA) => ({
  type: Auth.LOGIN,
  email,
  password,
  token2FA,
  method2FA,
});

/**
 * Action object dispatched when login fails
 *
 * @param {object} error
 */
const loginError = (error) => ({
  type: Auth.LOGIN_ERROR,
  error,
});

/**
 * Action object dispatched when login succeeds
 *
 * @param {object} action:
 * {
 *   @property {object} token: authentication token object
 *   @property {object} user: user payload
 * }
 */
const loginSuccess = ({ authToken: token, user }) => ({
  type: Auth.LOGIN_SUCCESS,
  token,
  user,
});

/**
 * Action object dispatched when the 2FA is required
 *
 * @param {object} action:
 * {
 *   @property {boolean} required2FA: 2FA enabled
 * }
 */
const login2FARequired = ({ required2FA, possible2faMethods }) => ({
  type: Auth.LOGIN_2FA_REQUIRED,
  required2FA,
  possible2faMethods,
});

/**
 * Action object dispatched when the 2FA is required
 *
 * @param {string} error:
 * {
 *   @property {boolean} required2FA: 2FA enabled
 * }
 */
const loginInvalid2FA = (error) => ({
  type: Auth.LOGIN_2FA_INVALID,
  error,
});

export default {
  login,
  loginError,
  loginSuccess,
  login2FARequired,
  loginInvalid2FA,
};
